import { useState, useEffect } from "react";
import {
    useRefinementList,
} from "react-instantsearch-hooks-web";
import algoliasearch from "algoliasearch/lite";
import { csvDownload } from "../../dashboard/AdminMetricDashboard/ExportCsv";
import toast from "react-hot-toast";
import ToastAlert from "../../custom-ui/toast-alert/ToastAlert";
import GreenUnderlineHeading from "../../custom-ui/headings/heading";
import { fetchResumeByUserId } from "../../../data/seeker";



const appId = process.env.REACT_APP_ALGOLIA_APP_ID!;
const apiKey = process.env.REACT_APP_ALGOLIA_API_KEY!;
const indexName = "UserQueries";




const fetchAllUsersByState = async (state: string) => {
    const searchClient = algoliasearch(appId, apiKey);
    const index = searchClient.initIndex(indexName);

    const hits: any[] = [];
    let page = 0;
    let hasMore = true;

    while (hasMore) {
        const res = await index.search("", {
            filters: `address.state:"${state}"`,
            page,

        });

        hits.push(...res.hits);
        hasMore = res.page + 1 < res.nbPages;
        page += 1;
    }

    console.log(`Fetched ${hits.length} users for state: ${state}`);

    return hits;
};

const DonwloadUsersListByState = () => {
    const [selectedState, setSelectedState] = useState("");
    const [loading, setLoading] = useState(false);
    const [csvUserData, setCsvUserData] = useState([]);

    const { items, refine, canRefine } = useRefinementList({
        attribute: "address.state",
        limit: 5000000,
    });




    const moveToLastLabels = ["Outside-USA", "No-Location"];

    const sortedItems = [...items]
        .sort((a, b) => {
            const aIsSpecial = moveToLastLabels.includes(a.label);
            const bIsSpecial = moveToLastLabels.includes(b.label);

            // If both are special → keep original order
            if (aIsSpecial && bIsSpecial) return 0;

            // If a is special → move it after b
            if (aIsSpecial) return 1;

            // If b is special → move it after a
            if (bIsSpecial) return -1;

            // Normal alphabetical sort
            return a.label.localeCompare(b.label);
        });


    let count = 0;

    useEffect(() => {
        if (!selectedState) return;

        setLoading(true);
        refine(selectedState);

        fetchAllUsersByState(selectedState)
            .then(async (users: any) => {
                const updatedUsers = await Promise.all(
                    users.map(async (user: any) => {

                        const resumeModels = await fetchResumeByUserId(user.objectID);
                        return {
                            Name: user.name || "N/A",
                            "Preferred Name": user.preferredName || "N/A",
                            Email: user.email || "N/A",
                            Phone: user.phone || "N/A",
                            Models:
                                resumeModels.length > 0
                                    ? resumeModels.join(", ") : "N/A",
                            Address: user.address?.standardizedAddress || "N/A",
                            City: user?.seekerLocationInfo?.city || "N/A",
                            State: user?.address?.state || "N/A",
                            "Zip Code": user?.seekerLocationInfo?.zipCode || "N/A",
                            "Military Affiliation": user?.claims?.milspouse ? "Military Spouse" : user?.claims?.milVerified ? "Military Verified" : "N/A",
                        };
                    })
                );

                setCsvUserData(updatedUsers);
            })
            .catch((err) => {
                console.error("❌ Error fetching data:", err);
            })
            .finally(() => setLoading(false));
    }, [selectedState]);


    const handleDownload = () => {


        if (csvUserData.length === 0) {
            toast.error("No data available to download.");
            return;
        }

        const now = new Date();
        const formattedDate = `${String(now.getMonth() + 1).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")}/${now.getFullYear()}`;
        const fileName = `OutreachByState_${selectedState}_${formattedDate}`;
        csvDownload(csvUserData, fileName);
    };



    return (
        <>
            <div className="w-full bg-white p-4 max-w-auto ">

                <GreenUnderlineHeading title="Outreach by State" />

                <div className="flex items-center w-[40%] ">
                    <div className="col-span-2">
                        {canRefine ? (
                            <select
                                id="stateSelect"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring hover:ring-instant-teams-blue-Main focus:border-instant-teams-blue-Main"
                                value={selectedState}
                                onChange={(e) => setSelectedState(e.target.value)}
                            >
                                <option value="">Select a state</option>
                                {sortedItems
                                    .map((item) => (
                                        <option key={item.label} value={item.label}>
                                            {item.label} ({item.count})
                                        </option>
                                    ))}
                            </select>
                        ) : (
                            <p className="text-gray-500 text-sm">Loading states...</p>
                        )}
                    </div>


                    <div className="cols-span-1 flex justify-end items-center">



                        {selectedState && !loading && <button
                            title="Download csv file"

                            onClick={handleDownload}
                            className="w-24 px-4 text-instant-teams-blue-Main"
                        >

                            <i
                                title="Download CSV File"
                                className={

                                    `fak fa-csv-download ${"fa-3x"} text-instant-teams-blue-Main`
                                }
                            ></i>

                        </button>}
                    </div>
                </div>

                {loading && (
                    <p className="text-blue-500 text-xs  mt-1">Fetching records...</p>
                )}


            </div>
            <ToastAlert />
        </>
    );
};

export default DonwloadUsersListByState;
